import React from 'react';
import { BackButtonStyles } from '../styles/backButton';
import { Box, Link } from '@material-ui/core';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { routeMappings } from '../../constants/routeMappings';
import { useBasicDetails } from '../../store/storeApi';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isArabicLocale } from '../../common/utils/checkLocalePlayer';

const BackButton = (): JSX.Element => {
  const { currentWorkflowItem } = useBasicDetails();
  const history = useHistory();
  const classes = BackButtonStyles();
  const { t } = useTranslation();

  const goBack = (): void => {
    history.push(`${routeMappings[currentWorkflowItem.code]}/${currentWorkflowItem.id}`);
  };

  return (
    <Box pt={5}>
      <Link className={classes.homeButton} onClick={goBack}>
        <FontAwesomeIcon icon={isArabicLocale() ? faAngleRight : faAngleLeft} size="lg" color="inherit" />
        <Box component="span" pl={2}>
          {t('returnHome')}
        </Box>
      </Link>
    </Box>
  );
};

export default BackButton;
